import { Form, Switch } from "antd";
import { DiffRow, fmtBool } from "pages/settings/policy/PolicySettingsPage";
import { PolicySection } from "pages/settings/policy/policySection";
import { SettingRow, SettingsSection } from "pages/settings/settingsRows";
import { translate } from "shared/languages";

const KEY = "schedule-conflict";

type Values = {
  schedule_conflict_prevention_enabled: boolean;
};

// Independent of Ketersediaan Instruktur: this only needs existing
// schedule_v2 rows, so it works whether or not that feature is on. See
// assertInstructorAvailable (schedule_v2.ts) for the enforcement.
const Fields = () => {
  const toggleLabel = translate("class_settings.schedule_conflict.toggle");
  return (
    <SettingsSection
      id={KEY}
      title={translate("class_settings.schedule_conflict.title")}
      description={translate("class_settings.schedule_conflict.description")}
    >
      <SettingRow
        last
        title={toggleLabel}
        control={
          <Form.Item name="schedule_conflict_prevention_enabled" valuePropName="checked" noStyle>
            <Switch aria-label={toggleLabel} />
          </Form.Item>
        }
      />
    </SettingsSection>
  );
};

export const scheduleConflictPolicy: PolicySection = {
  key: KEY,
  initialValues: (s) => ({
    schedule_conflict_prevention_enabled: s.schedule_conflict_prevention_enabled,
  }),
  buildSave: (v: Values, s) => {
    const isEnabled = !!v.schedule_conflict_prevention_enabled;
    const rows: DiffRow[] = [];
    if (isEnabled !== s.schedule_conflict_prevention_enabled) {
      rows.push({
        label: translate("class_settings.schedule_conflict.toggle"),
        before: fmtBool(s.schedule_conflict_prevention_enabled),
        after: fmtBool(isEnabled),
      });
    }
    return {
      rows,
      payload: { schedule_conflict_prevention_enabled: isEnabled },
      note: translate("class_settings.confirm.note_schedule_conflict"),
    };
  },
  Fields,
};
